import React, { Component } from 'react';
import api from '../../ApiService';
import FormLabel from '@material-ui/core/FormLabel';
import { FileUpload } from 'primereact/fileupload';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { toast } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

export default class VetdataRevenueMappings extends Component {
    constructor() {
        super();

        this.state = {
            selectedFile: "",
            load: false,
            importFile: { fileBytes: "" },
            importProcessed: false,
            loadingMappings: false,
            loadingSummary: false,
            mismappingsTable: [],
            missingItemCount: "",
            mappingViewTabs: []
        };
    }

    componentDidMount = async () => {
        this.setState({ loadingSummary: true });
        var result = await api.getMissingItemsVetdataCount();

        this.setState({ missingItemCount: result.missingItemCount, loadingSummary: false });
    }

    //---------------------
    // File upload handlers
    //---------------------
    onBeforeSend = (e) => {
        e.xhr.setRequestHeader('authorization', `Bearer ${localStorage.getItem('token')}`);
        toast.warn("Uploading file...", { autoClose: false, position: 'bottom-right' });
    }

    onUpload = async (e) => {
        toast.dismiss();
        toast.success('Upload successful.');

        this.setState({ loadingMappings: true, loadingSummary: true, importProcessed: true });

        let mismappingsTable = await api.getMissingItemsVetdata();
        let result = await api.getMissingItemsVetdataCount();

        this.setState({ loadingMappings: false, mismappingsTable, missingItemCount: result.missingItemCount, loadingSummary: false });
    }

    onError = (e) => {
        toast.error('Trouble uploading file.', { autoClose: 5000 });
    }

    renderFileDropzone() {
        let url = `api/revenuemappings/missingitemsvetdata`;
        let label = 'Upload Vetdata Revenue Mappings';
        if (this.state.isDirty === true) label += ' (disabled due to pending edits)';
        return (
            <div>
                <FormLabel component='span'>{label}</FormLabel>
                <FileUpload name='xlsxFile' url={url} auto accept=".xlsx,.XLSX" chooseLabel="CHOOSE" style={{ backgroundColor: 'gray' }}
                    onBeforeSend={this.onBeforeSend} onUpload={this.onUpload} onError={this.onError}
                />
            </div>
        );
    }

    renderSummaryTable() {
        return (
            <Table xs={10}>
                <TableHead>
                    <TableRow className="validation-table-highlight">
                        <TableCell component="th" style={{ textAlign: 'left', fontWeight: '500', fontSize: 'unset', color: 'black' }}># of Mismappings</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>{this.state.missingItemCount}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

    renderDetailsTable() {
        // Note!: If you add resizeablecolumns then the dropdown expands only in the active cell - effectively hiding it

        return (
            <div>
                <DataTable value={this.state.mismappingsTable}>
                    <Column field="intacctLocationId" header="IntacctLocationId" sortable="true" style={{ width: '25%' }} />
                    <Column field="intacctItemId" header="IntacctItemId" sortable="true" style={{ width: '25%' }} />
                    <Column field="itemId" header="ItemId" sortable="true" style={{ width: '50%' }} />
                </DataTable>
            </div>
        );
    }

    render() {
        let summaryTable = this.state.loadingSummary ? <em>Loading...</em> : this.renderSummaryTable();
        let fileDropzone = this.renderFileDropzone();
        let mappingDetails = this.state.loadingMappings ? <em>Loading...</em> : this.renderDetailsTable();

        return (
            <div>
                <br />
                {summaryTable}
                <hr />
                {fileDropzone}
                <hr />
                {this.state.importProcessed &&
                    mappingDetails
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Mappings/VetdataRevenueMappings.js